import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Loader, Icon } from 'rsuite';

const ExportButton = ({ isLoading, onClick, ...restProps }) => (
  <Button {...restProps} onClick={onClick} disabled={isLoading}>
    {isLoading ? (
      <Loader />
    ) : (
      <Fragment>
        <Icon icon="export" /> Export
      </Fragment>
    )}
  </Button>
);

ExportButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ExportButton;
